$(document).ready(function() {
	if( !document.querySelector('.GPC0011') ) return false;
	var $obj=$('.GPC0011');
	var tab_sticky = function() {
		var p = tab_sticky.prototype;
		var $this = $(".GPC0011"),
			$tabMenuList = $this.find(".tab-menu-belt"),
			$linkers = $tabMenuList.find('.linker'),
			$templateBase = $this.find('template.extra-menu-template').clone();
			$stickyTab = $this.find(".product-stickytab");
			$legal = $this.find('.legal');
		var discountedMsg = $('.GPC0009').find('.discountMessage').val();
			$legal.text(discountedMsg);
		var rPrice = $('.GPC0009').find('.component-rPrice').val();
		var rPromoPrice = $('.GPC0009').find('.component-rPromoPrice').val();
		// LGCOMMON-54 Start
		const rPriceCent = $('.GPC0009').find('.component-rPriceCent').val();
		const rPromoPriceCent = $('.GPC0009').find('.component-rPromoPriceCent').val();
		const vipPriceFlag = $('.GPC0009').find('.vipPriceFlag').val() == 'Y' ? true : false;
		// LGCOMMON-54 End
		var cookieBannerFixed = false;
			$this.find('template.extra-menu-template').remove();

		var energyLabelUseFlag = $("#energyLabelFlag").val();
		//PJTQUICKWIN ADD
		if(energyLabelUseFlag == 'Y'||(rPrice != '' && rPrice != null)){
			$stickyTab.addClass('active-energy');
		}
		//PJTQUICKWIN END
		// sticky by page scroll
		var	cutLine = parseInt( $this.closest(".component-wrap").offset().top );
		$(window).on("load resize", function(){
			cutLine = parseInt( $this.closest(".component-wrap").offset().top );
			return cutLine;
		});
		var cutLineMo = parseInt($(".iw_viewport-wrapper").offset().top);
		$(window).on("load resize", function(){
			var cutLineMo = parseInt($(".iw_viewport-wrapper").offset().top);
			return cutLineMo;
		});

		var im;
		var checkImgNum = 0;
		function checkImgLoad() {
			var cntLoad = 0,
				cntLoaded = 0;
			$('.component').each(function() {
				if(!$(this).hasClass('.GPC0009')) {
					if($(this).find('.slick-initialized ').length==0) {
						cntLoad = cntLoad + $(this).find('img.lazyloaded').length;
						cntLoaded = cntLoaded + $(this).find('img[data-loaded=true]').length;
					} else {
						cntLoad = cntLoad + parseInt($(this).find('.slick-active').length);
						cntLoaded = cntLoaded + parseInt($(this).find('.slick-active').length);
					}
				}
			});
			checkImgNum ++;
			//console.log(cntLoad, cntLoaded, checkImgNum);
			if((cntLoad <= cntLoaded) || checkImgNum >= 20) { // Maximum of 2 seconds
				return true;
			} else {
				return false;
			}
		}
		function getTargetScrollTop(target) {
			var objTop = $(target).offset().top - 62;		
			var hasPadding = ["#pdp_review", "#pdp_spec"];
			if(hasPadding.indexOf(target) >= 0) {
				objTop = objTop - 50;
			}
			if(!$this.hasClass('sticky-active')) {
				objTop = objTop - 62;
			}
			if(standardData.pdpStatus == "DISCONTINUED"){
				objTop = objTop + 50;
			}
			return objTop;
		}
		$linkers.on('click', function(e){
			e.preventDefault();
			var target = $(this).attr('href');
			var thisLinker = $(this);
			if($('img.lazyload').length>0) {

				$('img.lazyload').each(function() {
					//lazySizes.loader.unveil($(this).get(0));
					$(this).attr('src', $(this).attr('data-src')).removeClass('lazyload').addClass('lazyloaded');
				});

				im = setInterval(function() {
					var r = checkImgLoad();
					if(r) {
						clearInterval(im);
						setTimeout(function() {
							if($(target).length>0) {
								p.scrollToMenu(target, thisLinker); // LGECI-259
							}
						}, 100);
					}
				}, 100);
			} else {
				setTimeout(function() {
					if($(target).length>0) {
						p.scrollToMenu(target, thisLinker);
					}
				}, 100);
			}
		});

		p.init = function(){
			if(document.location.hash !=null && document.location.hash !=""){
				/* LGEGMC-255 add*/ 
				if(document.location.hash=='#pdp_where' && (typeof getCookie(ePrivacyCookies.countrycode+'_eCookieOpenFlag') =='undefined' && typeof getCookie(ePrivacyCookies.countrycode+'_agreeCookie') =='undefined') ||(typeof ePrivacyCookies=='undefined' || !ePrivacyCookies.get('LGCOM_ANALYSIS_OF_SITE'))){
					cookieBannerFixed=true;
					$('.cookie-banner').css({
						position:'fixed',
						width:'100%',
						display:'none',
						transition: 'all 0.5s ease',
						transform: 'translateY(-100%)'
					})
				}
				/*//LGEGMC-255 add*/
				this.scrollEvent();
			}
			this.eventOn();
			var els = document.querySelectorAll('.GPC0011');
			var waNumber = 0;
			var $target;
			if($(els).find('.product-simple-info .product-name') && !$(els).find('.product-simple-info .product-name').is(':empty')) {
				$target = $(els).find('.product-simple-info .product-name');
			}
			if($target) {
				$target.eq(0).attr('id', 'waGPC0011_'+waNumber);
				/* PJTOBS 20200603 add */
				$(els).find('a.extra-primary, a.extra-secondary').attr('aria-describedby', 'waGPC0011_'+waNumber);
				/* //PJTOBS 20200603 add */
				waNumber++;
			}
			
			//LGEGMC-177
			if ($('.GPC0009').length ) {
				var energyLabelFlag = $("#energyLabelFlag").val();
				var productFicheFileName = $("#productFicheFileName").val();
				var productFicheOriginalName = $("#productFicheOriginalName").val();
				var energyLabel = $("#energyLabel").val();
				var energyLabelDocId = $("#energyLabelDocId").val();
				var energyLabelFileName = $("#energyLabelFileName").val();
				var productFicheDocId = $("#productFicheDocId").val();
				var energyLabelOriginalName = $("#energyLabelOriginalName").val();
				var pdfDownloadFile = $("#pdfDownloadFile").val();
				var productFicheDownload = $("#productFicheDownload").val();
				//LGESR-72
				var rsProductFicheDownload = $("#rsProductFicheDownload").val();
				var rsUseFlag = $("#rsUseFlag").val();
				if(rsUseFlag == "Y"){
					productFicheDownload = rsProductFicheDownload;
				}
				//LGESR-72
				var energyLabelImageAddr = $("#energyLabelImageAddr").val();
				var energyLabelName = $("#energyLabelName").val();
				/*LGEGMC-926 s*/
				var fEnergyLabelDocId = $("#fEnergyLabelDocId").val();
				var fEnergyLabelFileName = $("#fEnergyLabelFileName").val();
				var fEnergyLabelOriginalName = $("#fEnergyLabelOriginalName").val();
				/*LGEGMC-926 e*/
				//LGEEG-154
				var buyNowUnionStoreBtnFlag = $(".component-buyNowUnionStoreBtnFlag").val();
				var obsPartnerUrl = $(".component-obsPartnerUrl").val();
				var opensInANewWindow = $(".component-opensInANewWindow").val();
				var unionStoreText = $(".component-unionStoreText").val();
				var buyNowUnionStore = $(".component-component-buyNowUnionStore").val();
				//LGEEG-154
				//LGEGMC-3921
				var secondEnergyLabel = $("#secondEnergyLabel").val();
				var secondEnergyLabelFileName = $("#secondEnergyLabelFileName").val();
				var secondEnergyLabelOriginalName = $("#secondEnergyLabelOriginalName").val();
				var secondProductFicheFileName = $("#secondProductFicheFileName").val();
				var secondProductFicheOriginalName = $("#secondProductFicheOriginalName").val();
				var secondEnergyLabelDocId = $("#secondEnergyLabelDocId").val();
				var secondProductFicheDocId = $("#secondProductFicheDocId").val();
				var secondEnergyLabelImageAddr = $("#secondEnergyLabelImageAddr").val();
				var secondEnergyLabelName = $("#secondEnergyLabelName").val();
				var secondEnergyLabelCategory = $("#secondEnergyLabelCategory").val();
				var washTowerFlag = $("#washTowerFlag").val();
				var secondFEnergyLabelDocId = $("#secondFEnergyLabelDocId").val();
				var secondFEnergyLabelFileName = $("#secondFEnergyLabelFileName").val();
				var secondFEnergyLabelOriginalName = $("#secondFEnergyLabelOriginalName").val();
				var energyLabelproductLeve1Code = $("#energyLabelproductLeve1Code").val();
				var fenergyLabelproductLeve1Code = $("#fenergyLabelproductLeve1Code").val();
				var productFicheproductLeve1Code = $("#productFicheproductLeve1Code").val();
				var secondEnergyLabelproductLeve1Code = $("#secondEnergyLabelproductLeve1Code").val();
				var secondFEnergyLabelproductLeve1Code = $("#secondFEnergyLabelproductLeve1Code").val();
				var secondProductFicheproductLeve1Code = $("#secondProductFicheproductLeve1Code").val();
				//LGEGMC-3921
				//PJTGADL-2
				var buName1 = $("#buName1").val();
				var buName2 = $("#buName2").val();
				var buName3 = $("#buName3").val();
				var modelName = $("#modelName").val();
				var superCategoryEngName = $("#superCategoryEngName").val();
				var salesSuffixCode = $("#salesSuffixCode").val();
				var salesModelCode = $("#salesModelCode").val();
				var modelId = $("#modelId").val();
				var modelYear = $(".js-compare").attr('data-model-year');
				var salesModelCode = $(".js-compare").attr('data-model-salesmodelcode');
				var filelist = $("#file-list");
				var buttonArea = $(".extra-area");
				var btnHtml = "";
				//LGEGMC-5315
				var docTypeCodeFlag =  $("#docTypeCodeFlag").val();
				if(docTypeCodeFlag == "N" || ((docTypeCodeFlag == "N" || docTypeCodeFlag == "O") && washTowerFlag=="Y")){
					var productFicheDownload = $("#productNewFicheDownload").val();
				}else if(docTypeCodeFlag == "O"){
					var productFicheDownload = $("#productOldFicheDownload").val();
				}
				//LGEGMC-5315
				
                if(energyLabelFlag == 'Y'){
                	$sellingInfo = $this.find('.product-selling-info');
                	var html = "";
                	//LGEGMC-3921
                	//LGEGMC-5315
        			if(docTypeCodeFlag != "N" && docTypeCodeFlag != "O"){
	                	if(washTowerFlag=="Y"){
	                		if( productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !="" && secondProductFicheFileName !="" && secondProductFicheOriginalName !="" && secondProductFicheFileName != null && secondProductFicheOriginalName !=null && secondProductFicheDocId !=null && secondProductFicheDocId !=""){
	                			html += "<div class='energy-label-wrap'><a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text text-tooltip' title='" + pdfDownloadFile + "'>"
	                			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
	                			+ "</a>"+ "<div class='tooltip-link'><div class='tolltip-inner'>";
								html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+productFicheDocId+ "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  +"'  data-file='"+productFicheFileName+"' data-original='"+productFicheOriginalName+"' data-category='' class='link-text link-text-uk' title='" + pdfDownloadFile +"("+productFicheproductLeve1Code+")"+ "'>"+productFicheproductLeve1Code+"</a>";
								html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + secondProductFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + secondProductFicheFileName + "' data-original='" + secondProductFicheOriginalName + "'  data-category='' class='link-text link-text-eu' title='" + pdfDownloadFile +"("+secondProductFicheproductLeve1Code+")"+ "'>"+secondProductFicheproductLeve1Code+"</a>"
								+ "</div></div></div>";
	                		}else{
	                			if(productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !=""  ){
	                				 html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile +"("+productFicheproductLeve1Code+")"+ "'>"
	                     			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
	                     			+ "</a>";
	    	                	}
	                		}
	                	}else{
	                		if(productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !=""  ){
		                		 html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile +"("+productFicheproductLeve1Code+")"+ "'>"
		                			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
		                			+ "</a>";
		                	}
	                	}
        			}
        			//LGEGMC-5315
                	//LGEGMC-3921
                	
                		/*LGEGMC-926 s*/
                	if(COUNTRY_CODE.toLowerCase()=="uk"){
                		if(energyLabel != "" && energyLabel != "N" && energyLabel != null && energyLabelFileName !=null && energyLabelFileName != "" && energyLabelOriginalName != null && energyLabelOriginalName !="" && energyLabelName != null
	                			&& energyLabelName !="" && energyLabelImageAddr != null && energyLabelImageAddr !=""&&fEnergyLabelFileName !='null' && fEnergyLabelDocId !='null' && fEnergyLabelDocId !='' && fEnergyLabelFileName !='' && fEnergyLabelOriginalName !='null' && fEnergyLabelOriginalName !='' ){
                			html += "<div class='energy-label-wrap'><a href='#' class='label-link'><span class='label'>"
								+"<img src='" + energyLabelImageAddr + "'  alt='" +energyLabelName + "'>"
							+ "</span></a><div class='tooltip-link'><div class='tolltip-inner'>";
							if(energyLabel !='' && energyLabel != 'N' && energyLabel !='null' && fEnergyLabelFileName !='null' && fEnergyLabelDocId !='null' && fEnergyLabelDocId !='' && fEnergyLabelFileName !='' && fEnergyLabelOriginalName !='null' && fEnergyLabelOriginalName !=''){
								html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+fEnergyLabelDocId+ "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  +"'  data-file='"+fEnergyLabelFileName+"' data-original='"+fEnergyLabelOriginalName+"' data-category='' class='link-text link-text-uk' title='" + pdfDownloadFile +"("+fenergyLabelproductLeve1Code+")"+ "'>"+$(".link-text-uk:eq(0)").text()+"</a>";
							}
							html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + energyLabelDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + energyLabelFileName + "' data-original='" + energyLabelOriginalName + "'  data-category='' class='link-text link-text-eu' title='" + pdfDownloadFile +"("+energyLabelproductLeve1Code+")"+ "'>"+$(".link-text-eu:eq(0)").text()+"</a>"
							+ "</div></div></div>";
                		}else{
                			if(energyLabel != "" && energyLabel != "N" && energyLabel != null && energyLabelFileName !=null && energyLabelFileName != "" && energyLabelOriginalName != null && energyLabelOriginalName !="" && energyLabelName != null
    	                			&& energyLabelName !="" && energyLabelImageAddr != null && energyLabelImageAddr !=""  ){
    	                		html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + energyLabelDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + energyLabelFileName + "' data-original='" + energyLabelOriginalName + "'  data-category='' class='link-text' title='" + pdfDownloadFile +"("+energyLabelproductLeve1Code+")"+ "'>"
    	            	        + "<span class='label type-none'>";
    	                	 html += "<img src='" + energyLabelImageAddr + "' alt='" +energyLabelName + "'>";
    	                	
    	                	html += "</span></a>";
    	                	}
                		}
                	}else{
	                	if(energyLabel != "" && energyLabel != "N" && energyLabel != null && energyLabelFileName !=null && energyLabelFileName != "" && energyLabelOriginalName != null && energyLabelOriginalName !="" && energyLabelName != null
	                			&& energyLabelName !="" && energyLabelImageAddr != null && energyLabelImageAddr !=""  ){
	                		html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + energyLabelDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + energyLabelFileName + "' data-original='" + energyLabelOriginalName + "'  data-category='' class='link-text' title='" + pdfDownloadFile +"("+energyLabelproductLeve1Code+")"+ "'>"
	            	        + "<span class='label type-none'>";
	                	 html += "<img src='" + energyLabelImageAddr + "' alt='" +energyLabelName + "'>";
	                	
	                	html += "</span></a>";
	                	}
                	}
					/*LGEGMC-926 e*/
                	if(washTowerFlag=="Y"){
                	 if(COUNTRY_CODE.toLowerCase()=="uk"){
                		if(secondEnergyLabel != "" && secondEnergyLabel != "N" && secondEnergyLabel != null && secondEnergyLabelFileName !=null && secondEnergyLabelFileName != "" && secondEnergyLabelOriginalName != null && secondEnergyLabelOriginalName !="" && secondEnergyLabelName != null
	                			&& secondEnergyLabelName !="" && secondEnergyLabelImageAddr != null && secondEnergyLabelImageAddr !=""&& secondFEnergyLabelFileName !='null' && secondFEnergyLabelDocId !='null' && secondFEnergyLabelDocId !='' && secondFEnergyLabelFileName !='' && secondFEnergyLabelOriginalName !='null' && secondFEnergyLabelOriginalName !='' ){
                			html += "<div class='energy-label-wrap'><a href='#' class='label-link'><span class='label'>"
								+"<img src='" + secondEnergyLabelImageAddr + "'  alt='" +secondEnergyLabelName + "'>"
							+ "</span></a><div class='tooltip-link'><div class='tolltip-inner'>";
							html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+secondFEnergyLabelDocId+ "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  +"'  data-file='"+secondFEnergyLabelFileName+"' data-original='"+secondFEnergyLabelOriginalName+"' data-category='' class='link-text link-text-uk' title='" + pdfDownloadFile +"("+secondFEnergyLabelproductLeve1Code+")"+ "'>"+$(".link-text-uk:eq(0)").text()+"</a>";
							html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + secondEnergyLabelDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + secondEnergyLabelFileName + "' data-original='" + secondEnergyLabelOriginalName + "'  data-category='' class='link-text link-text-eu' title='" + pdfDownloadFile +"("+secondEnergyLabelproductLeve1Code+")"+ "'>"+$(".link-text-eu:eq(0)").text()+"</a>"
							+ "</div></div></div>";
                		}else{
                			if(secondEnergyLabel != "" && secondEnergyLabel != "N" && secondEnergyLabel != null && secondEnergyLabelFileName !=null && secondEnergyLabelFileName != "" && secondEnergyLabelOriginalName != null && secondEnergyLabelOriginalName !="" && secondEnergyLabelName != null
    	                			&& secondEnergyLabelName !="" && secondEnergyLabelImageAddr != null && secondEnergyLabelImageAddr !=""  ){
    	                		html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + secondEnergyLabelDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + secondEnergyLabelFileName + "' data-original='" + secondEnergyLabelOriginalName + "'  data-category='' class='link-text' title='" + pdfDownloadFile +"("+secondEnergyLabelproductLeve1Code+")"+ "'>"
    	            	        + "<span class='label type-none'>";
    	                	 html += "<img src='" + secondEnergyLabelImageAddr + "' alt='" +secondEnergyLabelName + "'>";
    	                	
    	                	html += "</span></a>";
    	                	}
                		}
                	}else{
                		if(secondEnergyLabel != "" && secondEnergyLabel != "N" && secondEnergyLabel != null && secondEnergyLabelFileName !=null && secondEnergyLabelFileName != "" && secondEnergyLabelOriginalName != null && secondEnergyLabelOriginalName !="" && secondEnergyLabelName != null
	                			&& secondEnergyLabelName !="" && secondEnergyLabelImageAddr != null && secondEnergyLabelImageAddr !=""  ){
	                		html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + secondEnergyLabelDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + secondEnergyLabelFileName + "' data-original='" + secondEnergyLabelOriginalName + "'  data-category='' class='link-text' title='" + pdfDownloadFile +"("+secondEnergyLabelproductLeve1Code+")"+ "'>"
	            	        + "<span class='label type-none'>";
	                	 html += "<img src='" + secondEnergyLabelImageAddr + "' alt='" +secondEnergyLabelName + "'>";
	                	
	                	html += "</span></a>";
	                	}
                	  }
                	}
                	
                	//LGEGMC-5315
        			if(docTypeCodeFlag == "N" || docTypeCodeFlag == "O"){
	                	if(washTowerFlag=="Y"){
	                		if( productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !="" && secondProductFicheFileName !="" && secondProductFicheOriginalName !="" && secondProductFicheFileName != null && secondProductFicheOriginalName !=null && secondProductFicheDocId !=null && secondProductFicheDocId !=""){
	                			html += "<div class='energy-label-wrap'><a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text text-tooltip' title='" + pdfDownloadFile + "'>"
	                			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
	                			+ "</a>"+ "<div class='tooltip-link'><div class='tolltip-inner'>";
								html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+productFicheDocId+ "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  +"'  data-file='"+productFicheFileName+"' data-original='"+productFicheOriginalName+"' data-category='' class='link-text link-text-uk' title='" + pdfDownloadFile +"("+productFicheproductLeve1Code+")"+ "'>"+productFicheproductLeve1Code+"</a>";
								html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='" + secondProductFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + secondProductFicheFileName + "' data-original='" + secondProductFicheOriginalName + "'  data-category='' class='link-text link-text-eu' title='" + pdfDownloadFile +"("+secondProductFicheproductLeve1Code+")"+ "'>"+secondProductFicheproductLeve1Code+"</a>"
								+ "</div></div></div>";
	                		}else{
	                			if(productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !=""  ){
	                				 html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile +"("+productFicheproductLeve1Code+")"+ "'>"
	                     			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
	                     			+ "</a>";
	    	                	}
	                		}
	                	}else{
	                		if(productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !=""  ){
		                		 html += "<a href='#' adobe-click='pdp-file-down-click' data-doc='"+ productFicheDocId + "' data-bu= '" + buName1 + "' data-super-category-name= '" + superCategoryEngName + "' data-category-name= '" + buName2 + "' data-sub-category-name= '" + buName3 + "' data-model-year= '" + modelYear + "' data-model-name= '" + modelName + "' data-model-salesmodelcode= '" + salesModelCode + "' data-sku= '" + modelName + "' data-model-suffixcode= '" + salesSuffixCode  + "' data-model-id= '" + modelId  + "' data-file='" + productFicheFileName + "' data-original='" + productFicheOriginalName + "' data-category='' class='link-text' title='" + pdfDownloadFile +"("+productFicheproductLeve1Code+")"+ "'>"
		                			+ "<span class='fiche type-product'>" + productFicheDownload + "</span>"
		                			+ "</a>";
		                	}
	                	}
        			}
        			//LGEGMC-5315

							// LGCOMMON-54 Start
							// vip user + B2C model + Omnibus price
							if( ISVIP && $('#priceSyncTemplateGPC0011').length ){
								const omnibusPrice = vipPriceFlag ? rPrice : changeFormatFullPrice(rPrice, rPriceCent);
								const omnibusPromoPrice = vipPriceFlag ? rPromoPrice : changeFormatFullPrice(rPromoPrice, rPromoPriceCent);
								let priceType = '';
								let html = $('#priceSyncTemplateGPC0011').clone().html();
								$('#priceSyncTemplateGPC0011').remove();

								if(!!rPrice && rPrice != "0" && !!rPromoPrice && rPromoPrice != "0" && !!discountedMsg){
									html = html.replace(/\*discountMsg\*/g, discountedMsg)
										.replace(/\*rPrice\*/g, omnibusPrice)
										.replace(/\*rPromoPrice\*/g, omnibusPromoPrice)
									;

									priceType ='.rPromoPrice';
								}else if(!!rPrice && rPrice != "0"){
									html = html.replace(/\*rPrice\*/g, omnibusPrice);
									priceType ='.rPrice';
								}
								let omnibusPriceHtml = $(html).find(priceType).clone().html();
								$('.product-selling-price', $sellingInfo).html('').html(omnibusPriceHtml);
							}
							// LGCOMMON-54 End

                	//LGEIS-226
                	if((rPrice != "" || rPromoPrice != "") || (productFicheFileName !="" && productFicheOriginalName !="" && productFicheFileName != null && productFicheOriginalName !=null && productFicheDocId !=null && productFicheDocId !="")
                 	       || (energyLabel != "" && energyLabel != "N" && energyLabel != null && energyLabelFileName !=null && energyLabelFileName != "" && energyLabelOriginalName != null && energyLabelOriginalName !="" && energyLabelName != null
                             			&& energyLabelName !="" && energyLabelImageAddr != null && energyLabelImageAddr !=""  )){
              		    	$sellingInfo.addClass('active');
              		    } else{
              		    	$sellingInfo.removeClass('active');
              		    }
                	filelist.html(html);

					//LGEFR-640
					var labelUseFlag = $('#labelUseFlag').val();
					var repairabilityIndexFlag = $('#repairabilityIndexFlag').val();
					var repairLinkUrl = $('#repairLinkUrl').val();
					var repairLinkOpt = $('#repairLinkOpt').val();
					var repairImagePathAddr = $('#repairImagePathAddr').val();
					var repairAltText = $('#repairAltText').val();
					
					var repairAbilityArea = $('.GPC0011').find(".repairability-index");
					var targetBlankMsg = repairAbilityArea.attr('data-target-blank-msg');
					
					if(labelUseFlag == 'Y' && repairabilityIndexFlag == 'Y'){
						if($('.GPC0009').find('.repairability-index').length > 0){
							var repairAbilityHtml  = "<div class='score'>";
							if(repairLinkUrl != 'null' && repairLinkUrl != ''){
								repairAbilityHtml  += "<a href='"+repairLinkUrl+"'";
								if(repairLinkOpt =='S'){
									repairAbilityHtml  += " target='_self'";
								}else if(repairLinkOpt =='B'){
									repairAbilityHtml  += " target='_blank'";
								}
								repairAbilityHtml  += " title='"+targetBlankMsg+"' class='link-pdf'>";
							}else{
			                    repairAbilityHtml += "<span class='link-pdf'>";
			                }
							if(repairImagePathAddr != 'null' && repairImagePathAddr != ''){
								repairAbilityHtml  += "<img src='"+repairImagePathAddr+"' alt='"+repairAltText+"' area-hidden='true' />";
							}
							if(repairLinkUrl != 'null' && repairLinkUrl != ''){
								repairAbilityHtml  += "</a></div>";
							}else{
			                    repairAbilityHtml  += "</span></div>";
			                }
							repairAbilityArea.html(repairAbilityHtml);
						}else{
							repairAbilityArea.remove();
						}
					}else{
						repairAbilityArea.remove();
					} 
					//LGEFR-640 
				}
                //LGEEG-154
                if(buyNowUnionStoreBtnFlag == "Y"){
                	btnHtml += "<div class='button'>";
                	btnHtml += "<a href='#none' class='extra-menu extra-primary buyNowUnionBtn active' title='"+ opensInANewWindow +"' data-sc-item='buy-now-union-store' data-url='"+obsPartnerUrl+"' data-modal-text='"+unionStoreText+"' data-link-area='product_list-model_list' data-link-name='buy_now_union_store' data-content-id='"+modelId+"'>"+buyNowUnionStore+"</a>";
                	btnHtml += "</div>";
                	buttonArea.html(btnHtml);
                }
			
            //LGCOMMON-12724 Start
			//LGCOMMON-7821 Start
			var epsPictoFlag = $("#epsPictoFlag").val();
			var includeChargerYn = $("#includeChargerYn").val() == 'Y' ? '' : 'not-included';
			var usbPdYn = $("#usbPdYn").val() == 'Y' ? 'USB PD' : '';
			var minPower = $("#minPower").val();
			var maxPower = $("#maxPower").val();
			var epsDiv = $(".c-charging-device");
			var epsPictogramHtml = "";
			
			if(epsPictoFlag == "Y"){
				epsPictogramHtml += '<div class="c-info-charging">';
				epsPictogramHtml += '<i class="c-info-charging__icon ' + includeChargerYn + '" aria-hidden="true">';
				epsPictogramHtml += '<span class="c-info-charging__alt">';
				epsPictogramHtml += '<strong>' + minPower + ' - ' + maxPower + ' W</strong> ' + usbPdYn;
				epsPictogramHtml += '</span>';
				epsPictogramHtml += '</i>';
				epsPictogramHtml += '<div class="c-info-charging__text">';
				epsPictogramHtml += '<strong>' + minPower + ' - ' + maxPower + ' W</strong> ' + usbPdYn;
				epsPictogramHtml += '</div>';
				epsPictogramHtml += '</div>';
			}
			epsDiv.html(epsPictogramHtml);
			//LGCOMMON-7821 End       
			//LGCOMMON-12724 End
		}
		//PJTEXTENDEDWTY-4 (GPC0146컴포넌트가 존재할때만 warranty 탭이 나오게 변경 - 템플릿 머지를 안했을경우 안나오게 처리)
		if(!$('.GPC0146').length ){
			$('.tab-menu-belt a[href$="#pdp_warranty"]').closest(".tab-menu").css({display:'none'});
		}


			/* LGEGMC-255 add*/
			if(cookieBannerFixed){
				$('.cookie-banner').css({display:'block'});
				setTimeout(function() {
					$('.cookie-banner').css({
						transform: 'translateY(0)'
						})
				}, 1000);
			}
			/*//LGEGMC-255 add*/

			// LGECI-259 Start :: web accessibility
			var $defaultLabel = $tabMenuList.find('.tab-menu.active');
			$tabMenuList.attr('aria-label',$defaultLabel.text());
			// LGECI-259 End :: web accessibility

			// mobile 푸터높이 추가
			if($(".footer-box").length > 0 && $(".GPC0011").length > 0){
				// LGEITF-982 Start
				let footerBoxIdx = $(".footer-box").length;
				$('.footer-box:nth-child('+ footerBoxIdx +')').addClass("expand")
				// LGEITF-982 End
			}
		};

		p.checkAddcart = function(){
			if($("div").hasClass('GPC0022')) {		
				var $gpcHasbtn = $(".GPC0022");		
				if($(".GPC0011").hasClass('sticky-active')) {
					$gpcHasbtn.addClass("hasBtn")
				} else{
					$gpcHasbtn.removeClass("hasBtn")
				}
			}			
		};

		p.loadTabUi = function(){
			var $tabMoscroll = $('.tab-mo-scroll');	
			var windowWidth = $(window).outerWidth();
			if(windowWidth < 768){
				var set = $('.tab-menu');        
				var totalWidth = 0;
				set.each(function(){
					totalWidth = totalWidth + $(this).outerWidth(true);
				})
				if(windowWidth < totalWidth){
					setTimeout(function() {
						$tabMoscroll.mCustomScrollbar({
							axis:"x",
							mouseWheelPixels:100,
							callbacks:{							
								onScroll: function(){
									$(this).trigger('scrolled');
								},
								onTotalScroll: function(){
									$(this).trigger('totalScroll');
								},
								onTotalScrollBack: function(){
									$(this).trigger('totalScrollBack');
								}
							}
						});
					}, 500);
				} else{
					$tabMoscroll.mCustomScrollbar('destroy');
					$tabMoscroll.addClass('mCS_destroyed');
				}		
			} else{
				$tabMoscroll.mCustomScrollbar('destroy');				
			}
			stickytabControll = function () {
				var $stickytab = $('.tab-menu-box');
				$stickytab.on({
					click: function (e) {
						var current = e.currentTarget,
							scroll = e.delegateTarget.querySelector('.tab-mo-scroll');
						if ($(current).is('.scroll-left')) {
							$(scroll).mCustomScrollbar("scrollTo", '+=300',{
								scrollInertia:100
							});
						} else if ($(current).is('.scroll-right')) {
							$(scroll).mCustomScrollbar("scrollTo", '-=300',{
								scrollInertia:100
							});
						}
					}
				}, 'button');			
				$stickytab.find('.tab-mo-scroll').on({
					scrolled: function () {
						$('.tab-scroll-controller').find('.scroll-left').removeAttr('disabled');
						$('.tab-scroll-controller').find('.scroll-right').removeAttr('disabled');
					},
					totalScroll: function () {
						$('.tab-scroll-controller').find('.scroll-left').removeAttr('disabled');
						$('.tab-scroll-controller').find('.scroll-right').attr('disabled', 'disabled');
					},
					totalScrollBack: function () {
						$('.tab-scroll-controller').find('.scroll-left').attr('disabled', 'disabled');
						$('.tab-scroll-controller').find('.scroll-right').removeAttr('disabled');
					}
				});			
			};
			stickytabControll();
		};

		p.scrollEvent = function(){
			cutLine = parseInt($this.closest(".component-wrap").offset().top );
			cutLineMo = parseInt($(".iw_viewport-wrapper").offset().top);
			var scrollPos =  $(window).scrollTop();
			var stiky_condition = scrollPos >= parseInt(cutLine);
			var mo_stiky_condition = scrollPos >= parseInt(cutLineMo + 100);
			var windowWidth = $(window).width();
			var $tabMoscroll = $('.tab-mo-scroll');
			/* LGEGMC-255 add*/
			if(cookieBannerFixed){
				if(scrollPos < $('.cookie-banner').outerHeight()+$('.cookie-banner .default').outerHeight()){
					$('.cookie-banner').css({
						position:'relative',
						width:'auto'
					})
				}
			}
			/*//LGEGMC-255 add*/
			if(windowWidth < 768){
				p.scrollPosCheck(mo_stiky_condition);
				$tabMoscroll.mCustomScrollbar('update')
			} else{
				p.scrollPosCheck(stiky_condition);
				$tabMoscroll.mCustomScrollbar('destroy')
			}
			p.scrollAutoFocusing(scrollPos);
			p.checkAddcart(scrollPos);
		};

		// LGECI-259 Start :: web accessibility
		p.scrollToMenu = function(target, thisLinker){
			var ta = getTargetScrollTop(target);
			var $tabNav = thisLinker.closest('.tab-menu-belt'); 
			var activeLabel = thisLinker.text();
			$tabNav.attr('aria-label',activeLabel);
			$('html, body').stop().animate({scrollTop:ta}, {duration:500});
			$(target).attr('tabindex','0');
			$(target).focus();
			//$('body').trigger('ajaxLoadEnd');
		}
		// LGECI-259 End :: web accessibility

		p.eventOn = function(){
			/* LGCOMSPEED-6(6th) Start */			
			if(document.readyState == 'complete') loadResizeScript();
			$(window).on('load resize', loadResizeScript);
			function loadResizeScript(){
				p.loadTabUi();
				p.scrollPosCheck();
				p.checkAddcart();
			}
			/* LGCOMSPEED-6(6th) End */
			$(window).on('orientationchange' ,function(e) {
				if(window.orientation == '0'){
					$('.tab-mo-scroll').removeClass('mCS_destroyed')					
				}
			});
			$(window).on('scroll', function(){
				p.scrollEvent();
			});
			$this.on({
				changeSubModel: function(e, productInfo){
					var _target = e.currentTarget,
						price;

					// price & product name change
					if(productInfo.modelStatusCode=='DISCONTINUED') {
						$(_target).find('.product-selling-price .price').removeClass("active");
						$(_target).find('.product-selling-price .retailer').removeClass("active");
						$(_target).find('.product-selling-price .product-price').removeClass("active"); //PJTQUICKWIN
					} else if(productInfo.retailerPricingFlag == "Y") {
						_target.querySelector('.product-selling-price .retailer').innerHTML = productInfo.retailerPricingText;
						$(_target).find('.product-selling-price .price').removeClass("active");
						$(_target).find('.product-selling-price .retailer').addClass("active");
						$(_target).find('.product-selling-price .product-price').removeClass("active"); //PJTQUICKWIN
					}else if(productInfo.rPrice && productInfo.rPrice != null){
						if(productInfo.rPromoPrice != null) { // PJTOBS-32 : 오류 수정
							price = changeFormatFullPrice(productInfo.rPromoPrice, productInfo.rPromoPriceCent);
							_target.querySelector('.product-selling-price .price .number').innerHTML = price;
							$(_target).find('.product-selling-price .price').addClass("active");
							$(_target).find('.product-selling-price .retailer').removeClass("active");
							//PJTQUICKWIN
							if(productInfo.rPrice != null){
								var rPrice = changeFormatFullPrice(productInfo.rPrice, productInfo.rPriceCent);
								_target.querySelector('.product-selling-price .product-price .price .number').innerHTML = rPrice;
								 //[Start] LGEDE-1151 "has-uvp" 추가
		                        _target.querySelector('.product-selling-price .product-price .price.has-uvp .number').innerHTML = rPrice;
		                        //[End] LGEDE-1151
								$(_target).find('.product-selling-price .product-price').addClass("active");
							}
							if(productInfo.discountMsg != null){
								_target.querySelector('.product-selling-price .product-price .legal').innerHTML = productInfo.discountMsg;
								$(_target).find('.product-selling-price .product-price').addClass("active");
							}
							//PJTQUICKWIN
						}else {
							price = changeFormatFullPrice(productInfo.rPrice, productInfo.rPriceCent);
							_target.querySelector('.product-selling-price .price .number').innerHTML = price;
							$(_target).find('.product-selling-price .price').addClass("active");
							$(_target).find('.product-selling-price .retailer').removeClass("active");
							$(_target).find('.product-selling-price .product-price').removeClass("active"); //PJTQUICKWIN
						}
					}else {
						$(_target).find('.product-selling-price .price').removeClass("active");
						$(_target).find('.product-selling-price .retailer').removeClass("active");
						$(_target).find('.product-selling-price .product-price').removeClass("active"); //PJTQUICKWIN
					}
					// 20200512 START 박지영 - ufn null 처리
					_target.querySelector('.product-name').innerHTML = productInfo.userFriendlyName == null ? '' : productInfo.userFriendlyName;
					// 20200512 END

					// button controll
					var template = $templateBase.clone().html(),
						$template = null;
					if(productInfo.bizType.toUpperCase() == "B2B") {
						if(productInfo.inquiryToBuyFlag.toUpperCase() == "Y") {
							$template = $(template).filter('*[data-key="inquiryToBuyFlag"]');
							$template.href = productInfo.inquiryToBuyUrl;
						}else if(productInfo.findTheDealerFlag.toUpperCase() == "Y") {
							$template = $(template).filter('*[data-key="findTheDealerFlag"]');
							$template.href = productInfo.findTheDealerUrl;
						}
					}else {
						// PJTOBS 20200706 Start
						// PJTQUICKWIN-4_whereToBuy Start
						if(productInfo.whereToBuyFlag.toUpperCase() == "Y" && productInfo.whereToBuyUrl != null && productInfo.whereToBuyUrl != ''){
							$('.contents-menu-list').find('a[data-sc-item="where-to-buy"]').closest('.tab-menu').removeClass('imp-hide');	
							$('.component.GPC0011').find('.pdp-tab').removeClass('has-wtb');
						}
						// PJTQUICKWIN-4_whereToBuy End						
						if(productInfo.reStockAlertFlag=="Y") {
							$template = $(template).filter('*[data-key="reStockAlertFlag"]');
							$template.attr('data-model-id', productInfo.modelId).attr('href', '#');
						} else if(productInfo.addToCartFlag!="N") {
						// PJTOBS 20200706 End
							$template = $(template).filter('*[data-key="addToCartFlag"]');
							if(productInfo.addToCartFlag == 'Y') {
								$template.attr('data-model-id', productInfo.modelId).attr('href', '#').text(productInfo.productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
							} else if(productInfo.addToCartFlag == 'S') {
								$template.attr('data-model-id', productInfo.modelId).attr('href', '#').text(productInfo.productMessages.addToCartBtnNm).attr('role', 'button').removeAttr('target, title');
							}
						} else if(productInfo.buyNowFlag=="Y" || productInfo.buyNowFlag=="L") {
							$template = $(template).filter('*[data-key="addToCartFlag"]');
							if(productInfo.ecommerceTarget == '_blank'){
								$template.attr('data-model-id', productInfo.modelId).attr('href', productInfo.buyNowURL).text(productInfo.productMessages.buyNowBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productInfo.productMessages.btnNewLinkTitle);
							}else {
								$template.attr('data-model-id', productInfo.modelId).attr('href', productInfo.buyNowURL).text(productInfo.productMessages.buyNowBtnNm).removeAttr('role').removeAttr('target, title');
							}
						// 20200506 START 박지영 - flag 명 변경
						} else if (productInfo.resellerBtnFlag=="Y") {
						// 20200506 END
							// 20200507 START 박지영 - reseller 버튼 변경
							$template = $(template).filter('*[data-key="addToCartFlag"]');
							$template.attr('href', productInfo.resellerLinkUrl).text(productInfo.productMessages.resellerBtnNm).removeAttr('role').attr('target', '_blank').attr('title', productInfo.productMessages.btnNewLinkTitle);
							// 20200507 END
						} else if (productInfo.productSupportFlag=="Y") {
							// 20200507 START 박지영 - product support 버튼 변경
							$template = $(template).filter('*[data-key="addToCartFlag"]');
							$template.attr('href', productInfo.productSupportUrl).text(productInfo.productMessages.productSupportBtnNm).removeAttr('role').removeAttr('target, title');
							// 20200507 END
						// PJTQUICKWIN-4_whereToBuy Start
						}else if(productInfo.recommendedProductsUseFlag == "Y"){
							$template = $(template).filter('*[data-key="recommended_products"]');
						}else if(productInfo.whereToBuyFlag.toUpperCase() == "Y" && productInfo.whereToBuyUrl != null && productInfo.whereToBuyUrl != '') {
							$template = $(template).filter('*[data-key="whereToBuyFlag"]');
							$template.attr('href', productInfo.whereToBuyUrl).text(productInfo.productMessages.whereToBuyBtnNm);
							$template.removeAttr('target, title');
							if(!$template.hasClass('type-white')){
								$template.addClass('type-white');
							}
							if(productInfo.obsPreOrderFlag != 'Y' && productInfo.reStockAlertFlag != 'Y' && productInfo.resellerBtnFlag != 'Y' && productInfo.addToCartFlag != 'Y' && productInfo.addToCartFlag != 'S' && productInfo.buyNowFlag != 'Y' && productInfo.buyNowFlag != 'L' && productInfo.productSupportFlag != 'Y' && productInfo.whereToBuyFlag == 'Y'){
								$('.contents-menu-list').find('a[data-sc-item="where-to-buy"]').closest('.tab-menu').addClass('imp-hide');								
								if(!$('.component.GPC0011').find('.pdp-tab').hasClass('has-wtb')){
									$('.component.GPC0011').find('.pdp-tab').addClass('has-wtb');
								}
							}
						// PJTQUICKWIN-4_whereToBuy End	
						// 20200410 START 박지영 - wtb external link 변경
						} else if(productInfo.wtbExternalLinkUseFlag=="Y" && productInfo.wtbExternalLinkUrl != null && productInfo.wtbExternalLinkUrl != '' && productInfo.wtbExternalLinkName != null && productInfo.wtbExternalLinkName != '') {
							$template = $(template).filter('*[data-key="whereToBuyFlag"]');
							$template.attr('href', productInfo.wtbExternalLinkUrl).text(productInfo.wtbExternalLinkName);
							if(productInfo.wtbExternalLinkSelfFlag == 'Y') {
								$template.removeAttr('target, title');
							} else {
								$template.attr('target', '_blank').attr('title', productInfo.productMessages.btnNewLinkTitle);
							}
							$template.removeClass('type-white');
						}
						// 20200410 END
					}

					if($template != null) {
						template = $template.get(0).outerHTML;
					}else {
						template = '';
					}
					template = xssfilter(template, true);
					$(_target).find('.extra-menu').remove();
					// 20200408 START 박지영 : 개발과 UI에서 서로 다르게 처리한 부분 맞춤
					if($(_target).find('.extra-area div.button').length>0) {
						// 20200421 START 박지영 : 오타 수정
						$(_target).find('.extra-area div.button').append(template);
						// 20200421 END
					} else {
						$(_target).find('.extra-area').append(template);
					}
					// 20200408 END
				}
			});
		};

		p.scrollPosCheck = function(condition){
			// LGEUA-262 Start
			var $cookie_banner = $(".cookie-banner"),
				cookie_bannerHeight = $cookie_banner.height();
			// LGEUA-262 End
			var windowWidth = $(window).outerWidth();
			var scrollPos =  $(window).scrollTop();
			if(windowWidth > 767) {
				if(condition) {
					$cookie_banner.addClass('trans-full'); // LGEUA-262
					$this.addClass("sticky-active");
					var cookieDisplay = $cookie_banner.css("display"); // LGEUA-262
					if(cookieDisplay == "block" && $cookie_banner.hasClass('cookie-eu')){ // LGEUA-262
						$this.css("top", cookie_bannerHeight)
					} else {
						$this.css("top", "0");						
					}
				} else {				
					$cookie_banner.removeClass('trans-full'); // LGEUA-262
					$this.removeClass("sticky-active");
					$this.css("top", 'auto');
				}
			} else{
				$this.addClass("sticky-active");
				if(condition || scrollPos > 0) {					
					$this.removeClass("mo-zIndex");
					$('.tab-menu-box').addClass('on');
					var cookieDisplay = $cookie_banner.css("display"); // LGEUA-262
					if(cookieDisplay == "block" && $cookie_banner.hasClass('cookie-eu')){ // LGEUA-262
						$this.css("top", cookie_bannerHeight)
					} else {
						$this.css("top", "0");
					}
				}else{
					$('.tab-menu-box').removeClass('on');
					$this.addClass("mo-zIndex");
					$this.css("top", "0");					
				}
			}
		};
		p.scrollAutoFocusing = function(top){
			var onIdx = 0;
			for (var i = 0; i < $linkers.length; i++) {
				var linkerTarget = $linkers.eq(i).get(0).getAttribute('href');
				if($(linkerTarget).length>0) {var partTop = $(linkerTarget).offset().top - $this.outerHeight() - 50,
					hasPadding = ["#pdp_review", "#pdp_spec"];
					if(hasPadding.indexOf(linkerTarget) >= 0) {
						partTop = partTop - 50;
					}
					if(partTop <= top) {
						onIdx = i;
					}
				}
			}			
			// WA-GPC0011-01 : tab 영역 접근성을 위한 role 및 aria-selected 추가 시작
			$linkers.attr('aria-selected', false);
			$linkers.eq(onIdx).attr('aria-selected', true);
			// WA-GPC0011-01 : tab 영역 접근성을 위한 role 및 aria-selected 추가 끝
			$linkers.eq(onIdx).parent().addClass('active').siblings().removeClass('active');
		};
		p.init();
	};
	tab_sticky();
	// file download
	var fileDownload = function($link) {
		if($('form#formDown').length>0) $('form#formDown').remove();

		var fileBox = $link.closest('[data-file-download]');
		var flag = fileBox.data('flag').toUpperCase();
		var downtime = fileBox.data('downtime') || null;
		var opentime = fileBox.data('opentime') || null;

		if(flag=='Y') {
			// downtime error
			var $errorPop = $('#htmlOpenError');
			if($errorPop.length>0) {
				$errorPop.modal();
				$errorPop.find('.htmldowntime').text(downtime);
				$errorPop.find('.htmlopentime').text(opentime);
			} else {
				console.log('#htmlOpenError is required in HTML');
			}
		} else {

			var doc = $link.data('doc'),
				file = $link.data('file'),
				original = $link.data('original'),
				category = $link.data('category');

			var input = '<input type="hidden" id="DOC_ID" name="DOC_ID" value="' + doc +'" />';
			input += '<input type="hidden" id="ORIGINAL_NAME_b1_a1" name="ORIGINAL_NAME_b1_a1" value="' + original +'" />';
			input += '<input type="hidden" id="FILE_NAME" name="FILE_NAME" value="' + file +'" />';
			input += '<input type="hidden" id="TC" name="TC" value="DwnCmd" />';
			input += '<input type="hidden" id="GSRI_DOC" name="GSRI_DOC" value="GSRI" />'
			input += '<input type="hidden" id="SPEC_DOWNLOAD" name="SPEC_DOWNLOAD" value="N" />';

			/*LGEGMC-1035 start*/
            var openlocale="|AR|AT|BE_FR|BG|CH_DE|CH_FR|CZ|DE|DK|EE|ES|FI|FR|GR|HR|HU|IT|LT|LV|NL|NO|PL|PT|RO|RS|SE|SK|UK|";
            var _target="_self";
            if((original.toLowerCase().indexOf('.pdf')>-1 || original.toLowerCase().indexOf('.bmp')>-1 || original.toLowerCase().indexOf('.jpg')>-1 || original.toLowerCase().indexOf('.jpeg')>-1||original.toLowerCase().indexOf('.png')>-1) && openlocale.indexOf("|"+COUNTRY_CODE.toUpperCase()+"|")>-1){
            	_target="_blank";
            }
            
			var form = $('<form />').attr({
				id: 'formDown',
				method: 'get',
				action: fileBox.data('action'),
				target: _target
			}).append(input);
			$('body').append(form);
			/*LGEGMC-1035 end*/

			$('#formDown').submit();
		}
	}
	$obj.find('.file-list a.link-text').on('click', function(e) {
		e.preventDefault();
		fileDownload($(this));
	});
	/* GPC0009에 data-signatureFlag이 있을 경우 signatureFlag 상품 링크 삽  트래킹동작을 하지않아 주석처리
	if ($('.GPC0009').length > 0) {
		if ($('[data-signatureFlag]').length > 0) {
			$('[aria-controls=\"pdp_where\"]').attr({onclick : "fbq('track','Purchase');ttdWTB('" + $('#categoryId').val() + "');return false;"});
		}
	}*/
});
